// src/components/clients/TimelineEmailBadge.tsx
//
// Single-row email tracking badge. Reads from a shared trackingMap that
// ClientTimeline builds via one batch call to useEmailTracking. Each row
// looks up its own tracking_id and renders the badge inline.

import React from "react";
import EmailTrackingBadge from "./EmailTrackingBadge";
import type { TrackingData } from "../../hooks/useEmailTracking";

interface TimelineEmailBadgeProps {
  trackingId?: string;
  trackingMap?: Map<string, TrackingData>;
}

const TimelineEmailBadge: React.FC<TimelineEmailBadgeProps> = ({
  trackingId,
  trackingMap,
}) => {
  if (!trackingId || !trackingMap) return null;
  const data = trackingMap.get(trackingId);
  if (!data) return null;
  return <EmailTrackingBadge trackingData={data} />;
};

export default TimelineEmailBadge;
